package com.bikompanion.domain

/**
 * How a vote's [BikeKey.networkId] was arrived at.
 *
 * Recorded on the vote itself rather than inferred later, because it is the only way to tell a
 * confidently-scoped vote from a guess after the fact — a run of misattributed bikes in a city
 * looks very different depending on whether riders were picking networks by hand or a GPS fix
 * was landing in the wrong one.
 */
enum class BikeScopeSource {
    /** A real position fix from the device. */
    Gps,

    /** Where the map was pointed. If a rider panned there, they have implicitly said where they are. */
    MapCamera,

    /** The rider chose the network from a list. */
    ManualPick,
}
